document.querySelectorAll('#discount-button').forEach(anchor => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector(this.getAttribute("href")).scrollIntoView({
      behavior: "smooth"
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.custom-discount--wrapper', {
    loop: false,
    navigation: {
      nextEl: `.custom-discount--wrapper .swiper-button-next`,
      prevEl: `.custom-discount--wrapper .swiper-button-prev`,
    },
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 0,
    breakpoints: {
      1100: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      920: {
        slidesPerView: 2.3,
        spaceBetween: 30,
      },
      749: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      450: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
    },
  });

  new Swiper('.custom-instagram--wrapper', {
    loop: true,
    slidesPerView: 2.24,
    paginationClickable: true,
    spaceBetween: 9,
    breakpoints: {
      920: {
        slidesPerView: 4.8,
        spaceBetween: 9,
      },
      500: {
        slidesPerView: 4,
        spaceBetween: 9,
      },
      450: {
        slidesPerView: 3,
        spaceBetween: 9,
      },
    },
  });

  new Swiper('.custom-review--wrapper', {
    loop: false,
    navigation: {
      nextEl: `.custom-review--wrapper .swiper-button-next`,
      prevEl: `.custom-review--wrapper .swiper-button-prev`,
    },
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 0,
    breakpoints: {
      1100: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      920: {
        slidesPerView: 2.3,
        spaceBetween: 30,
      },
      749: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      450: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
    },
  });
});